
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homekwnicJK2nHG5PwZCTvdumsTAvd8POoBPlKW0JMmtxqUMeta } from "/vercel/path0/pages/home.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as leavesJ4mttqLUQqhMdwOH5vthcs0yZBFI4_459PAWf5bGvGv08Meta } from "/vercel/path0/pages/leaves.vue?macro=true";
import { default as searchE0nZQqeAMWsUG5cnJAPfFVP401IiagPhLDCR_YaJLbcMeta } from "/vercel/path0/pages/search.vue?macro=true";
import { default as ticketgLqGZJpaRQ4eQyDkryhH1_R_MFFqMv2HmdEjLfchpZYMeta } from "/vercel/path0/pages/ticket.vue?macro=true";
import { default as missivePQ8u42k6rUWeeAfefKOLtPbulHuzRQ10dYN9WKpjEMwMeta } from "/vercel/path0/pages/missive.vue?macro=true";
import { default as bulletinFo3_45PGPZxVQAqp9VClzRKiuYNRtMnJUpqpxip_Di5K4Meta } from "/vercel/path0/pages/bulletin.vue?macro=true";
import { default as grapeBotjsL4WxD7w8mNp9tKSixQib4pBlsWtYFbeQWbTrBFDGEMeta } from "/vercel/path0/pages/grapeBot.vue?macro=true";
import { default as caseFilingBN6bYnYIwfXL1nK8SaPs_454XAIrsYqYDaL9xDhiR8XDIMeta } from "/vercel/path0/pages/caseFiling.vue?macro=true";
import { default as timesheetstQ_45QCZhoAda_45fGf3uwXQGi2n2euYYyjYOde_45whJDc9oMeta } from "/vercel/path0/pages/timesheets.vue?macro=true";
import { default as translatorvqCn0_NV1v1_45ZcC5u5dpadueMDmDlCpXtBBqUcEmsNEMeta } from "/vercel/path0/pages/translator.vue?macro=true";
import { default as maintenanceS2D_452B_kVL2s2_45Fnro7E5I4H1bMe8HzzSXmiOWH5i_UMeta } from "/vercel/path0/pages/maintenance.vue?macro=true";
import { default as balanceFollowUp70FPGT_45RE5ARJwy2KTg3wF9Dz9SleZuVGKG2ISQAXJEMeta } from "/vercel/path0/pages/balanceFollowUp.vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    meta: homekwnicJK2nHG5PwZCTvdumsTAvd8POoBPlKW0JMmtxqUMeta || {},
    component: () => import("/vercel/path0/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "leaves",
    path: "/leaves",
    meta: leavesJ4mttqLUQqhMdwOH5vthcs0yZBFI4_459PAWf5bGvGv08Meta || {},
    component: () => import("/vercel/path0/pages/leaves.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchE0nZQqeAMWsUG5cnJAPfFVP401IiagPhLDCR_YaJLbcMeta || {},
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "ticket",
    path: "/ticket",
    meta: ticketgLqGZJpaRQ4eQyDkryhH1_R_MFFqMv2HmdEjLfchpZYMeta || {},
    component: () => import("/vercel/path0/pages/ticket.vue")
  },
  {
    name: "missive",
    path: "/missive",
    meta: missivePQ8u42k6rUWeeAfefKOLtPbulHuzRQ10dYN9WKpjEMwMeta || {},
    component: () => import("/vercel/path0/pages/missive.vue")
  },
  {
    name: "bulletin",
    path: "/bulletin",
    meta: bulletinFo3_45PGPZxVQAqp9VClzRKiuYNRtMnJUpqpxip_Di5K4Meta || {},
    component: () => import("/vercel/path0/pages/bulletin.vue")
  },
  {
    name: "grapeBot",
    path: "/grapeBot",
    meta: grapeBotjsL4WxD7w8mNp9tKSixQib4pBlsWtYFbeQWbTrBFDGEMeta || {},
    component: () => import("/vercel/path0/pages/grapeBot.vue")
  },
  {
    name: "caseFiling",
    path: "/caseFiling",
    meta: caseFilingBN6bYnYIwfXL1nK8SaPs_454XAIrsYqYDaL9xDhiR8XDIMeta || {},
    component: () => import("/vercel/path0/pages/caseFiling.vue")
  },
  {
    name: "timesheets",
    path: "/timesheets",
    meta: timesheetstQ_45QCZhoAda_45fGf3uwXQGi2n2euYYyjYOde_45whJDc9oMeta || {},
    component: () => import("/vercel/path0/pages/timesheets.vue")
  },
  {
    name: "translator",
    path: "/translator",
    meta: translatorvqCn0_NV1v1_45ZcC5u5dpadueMDmDlCpXtBBqUcEmsNEMeta || {},
    component: () => import("/vercel/path0/pages/translator.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/vercel/path0/pages/maintenance.vue")
  },
  {
    name: "balanceFollowUp",
    path: "/balanceFollowUp",
    meta: balanceFollowUp70FPGT_45RE5ARJwy2KTg3wF9Dz9SleZuVGKG2ISQAXJEMeta || {},
    component: () => import("/vercel/path0/pages/balanceFollowUp.vue")
  }
]